import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import LogoutButton from "./LogoutButton";

import { toast } from "../utils/toast";
import { useStudentProgress } from "../context/StudentProgressContext";

import "./Dashboard.css";
import { useExamdetailsViewModel } from "../viewModels/useExamDetailsViewMore";
import { useAdmissionDriveKind } from "../hooks/useAdmissionDriveKind";
import { useQueryClient } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import apiConfig from "../config/apiConfig";
import { apiFetch } from "../apis/apiFetch";
import { LoginContext } from "../context/LoginContext";
import { useContext, useEffect } from "react";
import jee_main_application_no from "../images/jee_main_scorecard_applno.png";
import { BTechApplicationFields } from "../config/btechApplicationFields";
import jee_main_nta_score from "../images/jee_main_scorecard_ntascore.png";
import jee_main_rank from "../images/jee_main_rank.png";
import jee_advanced_rank from "../images/jee_advanced_rank.png";
import RenderImage from "./QueryManager/RenderImage/RenderImage";
import { jeeMainApplicationRules, updateJeeAdvancedApplicationRules } from "../validators/applicantValidator";
import { validate } from "../utils/validator";
import moment from "moment";

interface DriveOption {
    id: string;
    name: string;
    type: string;
}

export default function JeeUpdate() {
    const navigate = useNavigate();
    const MF = BTechApplicationFields.jeemain;
    const AF = BTechApplicationFields.jeeadv;

    const [showDropdown, setShowDropdown] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const queryClient = useQueryClient();

    // assuming userId + appId available (same as other pages)
    const userId = "student"; // replace if from context
    const appId = "admission-portal";
    const [dataToSave, setDataToSave] = useState<any>({});
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [drives, setDrives] = useState<DriveOption[]>([]);

    const [showEnrollmentNoHelp, setShowEnrollmentNoHelp] = useState(false);
    const [showScoreHelp, setShowScoreHelp] = useState(false);
    const [showRankHelp, setShowRankHelp] = useState(false);
    const [showAdvRankHelp, setShowAdvRankHelp] = useState(false);
    // const [mainScorecard, setMainScorecard] = useState<File | string | null>(null);
    // const [dataToSave?.jeeadv_scorecard, setAdvScorecard] = useState<File | string | null>(null);
    const [mainPreview, setMainPreview] = useState<string | null>(null);
    const [advPreview, setAdvPreview] = useState<string | null>(null);
    const [mainPhotoError, setMainPhotoError] = useState("");
    const [advPhotoError, setAdvPhotoError] = useState("");

    const {
        save,
    } = useExamdetailsViewModel(userId, appId);

    // useEffect(() => {
    //     const row = dataToSave;
    //     if (!row) return;
    //     const msc = dataToSave?.jeemain_scorecard;
    //     const asc = dataToSave?.jeeadv_scorecard;
    //     setMainScorecard(msc instanceof File ? msc : (typeof msc === 'string' ? msc : null));
    //     setAdvScorecard(asc instanceof File ? asc : (typeof asc === 'string' ? asc : null));
    // }, [dataToSave]);

    const { user } = useContext(LoginContext);

    useEffect(() => {
        const fetchDrives = async () => {
            try {
                const res = await apiFetch(
                    `${apiConfig.getResourceUrl("drive")}?queryId=GET_ALL`,
                    { method: "GET" },
                );
                if (res.ok) {
                    const data = await res.json();
                    setDrives(
                        (data.resource || []).map((d: any) => ({
                            id: d.id,
                            name: d.name,
                            type: d.drivetype,
                        })),
                    );
                }
            } catch (err) {
                console.error("Error fetching drives:", err);
            }
        };

        fetchDrives()
    }, [])

    const { data: dataRes, isFetching } = useQuery({
        queryKey: ["jeeUpdate", user?.userId],
        queryFn: async () => {
            if (!user?.userId) return [];

            const response = await apiFetch(
                `${apiConfig.getResourceUrl("applications")}?queryId=GET_APPLICATIONS_BY_USER_ID&args=user_id:${user.userId}`,
                { method: "GET" }
            );

            if (!response.ok) {
                throw new Error("Error: " + response.status);
            }

            const data = await response.json();
            return data.resource || [];
        },
        enabled: !!user?.userId,
    });

    useEffect(() => {
        console.log("activeDriveId", dataRes)
        if (!isFetching && dataRes && dataRes.length > 0) {
            const userRecord = dataRes.find((r: any) =>
                r.user_id === user?.userId &&
                drives.find((drive) => drive?.id === r.drive_id)?.type === "Btech"
            );
            console.log("dataResdataRes", userRecord)
            if (userRecord) {

                setDataToSave((prev: any) => ({
                    ...userRecord,   // ✅ DB data
                    ...prev,         // ✅ preserve any edits
                }));
            }
        }
    }, [dataRes, user?.userId, isFetching]);

    const buildMainPayload = (): Record<string, unknown> => ({
        [MF.examtype]: MF.examtype || 'JEE Main',
        [MF.rollno]: dataToSave?.jeemain_rollno,
        [MF.score]: dataToSave?.jeemain_score,
        [MF.rank]: dataToSave?.jeemain_rank,
        [MF.scorecard]: dataToSave?.jeemain_scorecard,
    });

    const buildAdvPayload = (): Record<string, unknown> => ({
        [AF.examtype]: AF.examtype || 'JEE Advanced',
        [AF.rollno]: dataToSave?.jeeadv_rollno,
        [AF.score]: dataToSave?.jeeadv_score,
        [AF.rank]: dataToSave?.jeeadv_rank,
        [AF.scorecard]: dataToSave?.jeeadv_scorecard,
    });

    const isJeeEnabled = dataToSave?.status === "JEE_EDITING" || (dataToSave?.jee_main_verification_status === "JEE_EDITING" && dataToSave?.jee_advanced_verification_status === "JEE_EDITING")
    const isJeeMainEnabled = isJeeEnabled || dataToSave?.status === "JEE_MAIN_EDITING" || dataToSave?.jee_main_verification_status === "JEE_EDITING"
    const isJeeAdvAllowed = isJeeEnabled || dataToSave?.status === "JEE_ADV_EDITING" || dataToSave?.jee_advanced_verification_status === "JEE_EDITING"

    const handleCreate = async () => {
        const vErrors: Record<string, string> = {};

        if (true) {
            const mainPayload = buildMainPayload();
            const advPayload = buildAdvPayload();
            const jErrMain = validate(mainPayload as any, jeeMainApplicationRules);
            const jErrAdv = isJeeAdvAllowed ? validate(advPayload as any, updateJeeAdvancedApplicationRules) : null;
            console.log("jErrMain", jErrMain, jErrAdv, advPayload)

            Object.assign(vErrors, jErrMain, jErrAdv);
        }

        setErrors(vErrors);

        if (Object.keys(vErrors).length > 0) {
            toast.error("Please complete all required fields.");
            return;
        }

        setShowConfirmModal(true);
    };

    const executeSave = async () => {
        try {
            setIsSaving(true);
            setShowConfirmModal(false);

            console.log("dataToSave", dataToSave);

            const date = moment().toISOString();
            const lastUpdated: Record<string, any> = {};
            const verificationStatusUpdates: Record<string, any> = {};

            if (isJeeMainEnabled) {
                lastUpdated["last_updated_jee_main"] = date;
                if (dataToSave?.jee_main_verification_status === "JEE_EDITING") {
                    verificationStatusUpdates["jee_main_verification_status"] = "JEE_MAIN_RESUBMITTED";
                }
            }
            if (isJeeAdvAllowed) {
                lastUpdated["last_updated_jee_adv"] = date;
                if (dataToSave?.jee_advanced_verification_status === "JEE_EDITING") {
                    verificationStatusUpdates["jee_advanced_verification_status"] = "JEE_ADVANCED_RESUBMITTED";
                }
            }

            let newStatus = dataToSave?.status;
            if (dataToSave?.status === "JEE_EDITING") {
                newStatus = "JEE_EDIT_SUBMIT";
            } else if (dataToSave?.status === "JEE_MAIN_EDITING") {
                newStatus = "JEE_MAIN_EDIT_SUBMIT";
            } else if (dataToSave?.status === "JEE_ADV_EDITING") {
                newStatus = "JEE_ADV_EDIT_SUBMIT";
            }

            const finalPayload = {
                ...dataToSave,   // 🔥 EXISTING FULL APPLICATION DATA
                ...lastUpdated,
                ...verificationStatusUpdates,
                "status": newStatus
            };

            console.log("FINAL PAYLOAD", finalPayload);

            await save(finalPayload);

            queryClient.invalidateQueries({
                queryKey: ["jeeUpdate", user?.userId],
            });

            toast.success("Exam details saved successfully!");
            setTimeout(() => navigate("/applicant/home"), 1000);

        } catch (error) {
            console.error("Error saving exam details:", error);
            toast.error("Error updating details. Please try again.");
        } finally {
            setIsSaving(false);
        }
    };


    return (

        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>

            {/* Header */}
            <header className="dash-header">
                <h1 className="dash-page-title">Exam Details</h1>

                <div className="dash-user-profile">
                    <div
                        className="dash-profile-circle"
                        onClick={() => setShowDropdown((p) => !p)}
                    >
                        <span>S</span>
                    </div>

                    {showDropdown && (
                        <div className="dash-profile-dropdown">
                            <LogoutButton />
                        </div>
                    )}
                </div>
            </header>

            {/* Content */}
            {(isFetching || isSaving) ?
                <div> Loading </div> :
                <div className="dash-content-body">
                    <div className="form-container">
                        {/* <h3 className="form-subtitle">Exam Details</h3> */}

                        <div className="jee-forms-section" style={{ marginTop: "30px" }}>

                            {/* JEE Main */}

                            <div className="form-container">
                                <h3 className="form-subtitle">JEE Main 2026</h3>
                                <div className="form-grid">
                                    <div
                                        className="form-group"
                                        onMouseEnter={() => setShowEnrollmentNoHelp(true)}
                                        onMouseLeave={() => setShowEnrollmentNoHelp(false)}
                                        style={{ position: "relative" }}
                                    >
                                        <label className="form-label">JEE Main Application No. *</label>
                                        <input
                                            type="text"
                                            className={`form-input ${errors[MF.rollno] ? 'input-error' : ''}`}
                                            disabled={!isJeeMainEnabled}
                                            value={dataToSave?.["jeemain_rollno"] || ""}
                                            onChange={(e) => {
                                                setDataToSave((prev: any) => { return { ...prev, jeemain_rollno: e.target.value } })
                                                if (errors[MF.rollno]) setErrors((prev) => ({ ...prev, [MF.rollno]: '' }));
                                            }
                                            }
                                        />
                                        {errors[MF.rollno] && <span className="error-text">{errors[MF.rollno]}</span>}
                                        {showEnrollmentNoHelp && (
                                            <div className="jee-score-hover-preview">
                                                <div className="score-hover-header">
                                                    Please Enter the below <strong>JEE Main Application No.</strong> from your official scorecard.
                                                </div>

                                                <img
                                                    src={jee_main_application_no}
                                                    alt="Sample JEE Main Rank (CRL)"
                                                    className="score-hover-image"
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className="form-group"
                                        onMouseEnter={() => setShowScoreHelp(true)}
                                        onMouseLeave={() => setShowScoreHelp(false)}
                                        style={{ position: "relative" }}
                                    >
                                        <label className="form-label">JEE Main NTA Final Total Score (upto 7 decimal places) *</label>
                                        <input
                                            type="number"
                                            className={`form-input ${errors[MF.score] ? 'input-error' : ''}`}
                                            disabled={!isJeeMainEnabled}
                                            value={dataToSave?.["jeemain_score"] || ""}
                                            onChange={(e) => {
                                                setDataToSave((prev: any) => { return { ...prev, jeemain_score: e.target.value } })
                                                if (errors[MF.score]) setErrors((prev) => ({ ...prev, [MF.score]: '' }));
                                            }
                                            }
                                        />
                                        {errors[MF.score] && <span className="error-text">{errors[MF.score]}</span>}
                                        {showScoreHelp && (
                                            <div className="jee-score-hover-preview">
                                                <div className="score-hover-header">
                                                    Please Enter the below <strong>JEE Main NTA Score</strong> from your official scorecard.
                                                </div>

                                                <img
                                                    src={jee_main_nta_score}
                                                    alt="Sample JEE Main Rank (CRL)"
                                                    className="score-hover-image"
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className="form-group"
                                        onMouseEnter={() => setShowRankHelp(true)}
                                        onMouseLeave={() => setShowRankHelp(false)}
                                        style={{ position: "relative" }}
                                    >
                                        <label className="form-label">JEE Main Rank (CRL) *</label>
                                        <input
                                            type="number"
                                            className={`form-input ${errors[MF.rank] ? 'input-error' : ''}`}
                                            disabled={!isJeeMainEnabled}
                                            value={dataToSave?.["jeemain_rank"] || ""}
                                            onChange={(e) => {
                                                setDataToSave((prev: any) => { return { ...prev, jeemain_rank: e.target.value } })
                                                if (errors[MF.score]) setErrors((prev) => ({ ...prev, [MF.score]: '' }));
                                            }
                                            }
                                        />
                                        {errors[MF.rank] && <span className="error-text">{errors[MF.rank]}</span>}
                                        {showRankHelp && (
                                            <div className="jee-score-hover-preview">
                                                <div className="score-hover-header">
                                                    Please Enter the below <strong>JEE Main Rank (CRL)</strong> from your official scorecard.
                                                </div>

                                                <img
                                                    src={jee_main_rank}
                                                    alt="Sample JEE Main Rank (CRL)"
                                                    className="score-hover-image"
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className="form-group"
                                        // onMouseEnter={() => setShowScorecardHelp(true)}
                                        // onMouseLeave={() => setShowScorecardHelp(false)}
                                        style={{ gridColumn: "1 / -1", position: "relative" }}>
                                        <>
                                            <label className="form-label">JEE Main Scorecard *</label>

                                            <div className="file-upload-wrapper">
                                                <input
                                                    className={`form-input file-input ${errors[MF.scorecard] ? "input-error" : ""}`}
                                                    type="file"
                                                    accept="image/jpeg,image/png,image/jpg,application/pdf"
                                                    disabled={!isJeeMainEnabled}
                                                    onChange={(e) => {
                                                        const file = e.target.files?.[0] || null;

                                                        // ✅ File size validation (512 KB)
                                                        if (file && file.size > 512 * 1024) {
                                                            setMainPhotoError(
                                                                "Scorecard size must be less than 512 KB. Please choose a smaller file."
                                                            );
                                                            e.target.value = "";
                                                            return;
                                                        }

                                                        setMainPhotoError("");

                                                        // ✅ Update state
                                                        setDataToSave((prev: any) => { return { ...prev, jeemain_scorecard: file } })
                                                        // setMainScorecard(file);

                                                        // ✅ Generate preview
                                                        if (file) {
                                                            const objectUrl = URL.createObjectURL(file);
                                                            setMainPreview(objectUrl);
                                                        }

                                                        // ✅ Clear validation error
                                                        if (errors[MF.scorecard]) {
                                                            setErrors((prev) => ({
                                                                ...prev,
                                                                [MF.scorecard]: "",
                                                            }));
                                                        }
                                                    }}
                                                />
                                            </div>

                                            {/* ✅ File size error */}
                                            {mainPhotoError && (
                                                <span
                                                    style={{
                                                        color: "red",
                                                        fontSize: "0.8rem",
                                                        marginTop: "4px",
                                                        display: "block",
                                                    }}
                                                >
                                                    {mainPhotoError}
                                                </span>
                                            )}

                                            {/* ✅ Validation error */}
                                            {errors[MF.scorecard] && (
                                                <span className="error-text">{errors[MF.scorecard]}</span>
                                            )}

                                            {/* ✅ Helper text */}
                                            <small
                                                style={{
                                                    color: "#6b7280",
                                                    fontSize: "12px",
                                                    marginTop: "4px",
                                                    display: "block",
                                                }}
                                            >
                                                Max size: 512 KB | Formats: JPG, JPEG, PNG, PDF
                                            </small>
                                        </>

                                        {/* ✅ Preview OR Existing file */}
                                        {mainPreview ? (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    marginLeft: 100,
                                                    marginTop: 10,
                                                }}
                                            >
                                                <img src={mainPreview} alt="preview" style={{ maxWidth: "40%" }} />
                                            </div>
                                        ) : typeof dataToSave?.jeemain_scorecard === "string" && dataToSave?.jeemain_scorecard ? (
                                            <div>
                                                <small
                                                    style={{
                                                        color: "#1d1e1f",
                                                        fontSize: "12px",
                                                        marginTop: "4px",
                                                        display: "block",
                                                    }}
                                                >
                                                    Previous Uploaded File:
                                                </small>

                                                <RenderImage photo={dataToSave?.jeemain_scorecard} />
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            {/* JEE Advanced */}

                            <div className="form-container">
                                <h3 className="form-subtitle">JEE Advanced 2026 {" "}
                                </h3>
                                <div className="form-grid">
                                    <div
                                        className="form-group"
                                        style={{ position: "relative" }}
                                    >
                                        <label className="form-label">JEE Advanced Application / Roll Number {"*"}</label>
                                        <input
                                            type="text"
                                            className={`form-input ${errors[AF.rollno] ? 'input-error' : ''}`}
                                            disabled={!isJeeAdvAllowed}
                                            value={dataToSave?.["jeeadv_rollno"] || ""}
                                            onChange={(e) => {
                                                setDataToSave((prev: any) => { return { ...prev, jeeadv_rollno: e.target.value } })
                                                if (errors[AF.rollno]) setErrors((prev) => ({ ...prev, [AF.rollno]: '' }));
                                            }
                                            }
                                        />
                                        {errors[AF.rollno] && <span className="error-text">{errors[AF.rollno]}</span>}
                                    </div>
                                    <div
                                        className="form-group"
                                        // onMouseEnter={() => setShowScoreHelp(true)}
                                        // onMouseLeave={() => setShowScoreHelp(false)}
                                        style={{ position: "relative" }}
                                    >
                                        <label className="form-label">JEE Advanced Total Score / Marks {"*"}</label>
                                        <input
                                            type="number"
                                            className={`form-input ${errors[AF.score] ? 'input-error' : ''}`}
                                            disabled={!isJeeAdvAllowed}
                                            value={dataToSave?.["jeeadv_score"] || ""}
                                            onChange={(e) => {
                                                setDataToSave((prev: any) => { return { ...prev, jeeadv_score: e.target.value } })
                                                if (errors[AF.score]) setErrors((prev) => ({ ...prev, [AF.score]: '' }));
                                            }
                                            }
                                        />
                                        {errors[AF.score] && <span className="error-text">{errors[AF.score]}</span>}
                                    </div>
                                    <div
                                        className="form-group"
                                        onMouseEnter={() => setShowAdvRankHelp(true)}
                                        onMouseLeave={() => setShowAdvRankHelp(false)}
                                        style={{ position: "relative" }}
                                    >
                                        <label className="form-label">JEE Advanced Rank (CRL) {"*"}</label>
                                        <input
                                            type="number"
                                            className={`form-input ${errors[AF.rank] ? 'input-error' : ''}`}
                                            disabled={!isJeeAdvAllowed}
                                            value={dataToSave?.["jeeadv_rank"] || ""}
                                            onChange={(e) => {
                                                setDataToSave((prev: any) => { return { ...prev, jeeadv_rank: e.target.value } })
                                                if (errors[AF.rank]) setErrors((prev) => ({ ...prev, [AF.rank]: '' }));
                                            }
                                            }
                                        />
                                        {errors[AF.rank] && <span className="error-text">{errors[AF.rank]}</span>}
                                        {showAdvRankHelp && (
                                            <div className="score-hover-preview">
                                                <div className="score-hover-header">
                                                    Please Enter the below <strong>JEE Advanced Rank (CRL)</strong> from your official scorecard.
                                                </div>

                                                <img
                                                    src={jee_advanced_rank}
                                                    alt="Sample JEE Advanced Rank (CRL)"
                                                    className="score-hover-image"
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className="form-group"
                                        // onMouseEnter={() => setShowScorecardHelp(true)}
                                        // onMouseLeave={() => setShowScorecardHelp(false)}
                                        style={{ gridColumn: "1 / -1", position: "relative" }}>
                                        <>
                                            <label className="form-label">JEE Advanced Scorecard {"*"}</label>

                                            <div className="file-upload-wrapper">
                                                <input
                                                    className={`form-input file-input ${errors[AF.scorecard] ? "input-error" : ""}`}
                                                    type="file"
                                                    disabled={!isJeeAdvAllowed}
                                                    accept="image/jpeg,image/png,image/jpg,application/pdf"
                                                    onChange={(e) => {
                                                        const file = e.target.files?.[0] || null;

                                                        // ✅ File size validation (512 KB)
                                                        if (file && file.size > 512 * 1024) {
                                                            setAdvPhotoError(
                                                                "Scorecard size must be less than 512 KB. Please choose a smaller file."
                                                            );
                                                            e.target.value = "";
                                                            return;
                                                        }

                                                        setAdvPhotoError("");

                                                        // ✅ Update state
                                                        setDataToSave((prev: any) => { return { ...prev, jeeadv_scorecard: file } })

                                                        // ✅ Generate preview
                                                        if (file) {
                                                            const objectUrl = URL.createObjectURL(file);
                                                            setAdvPreview(objectUrl);
                                                        }

                                                        // ✅ Clear validation error
                                                        if (errors[AF.scorecard]) {
                                                            setErrors((prev) => ({
                                                                ...prev,
                                                                [AF.scorecard]: "",
                                                            }));
                                                        }
                                                    }}
                                                />
                                            </div>

                                            {/* ✅ File size error */}
                                            {advPhotoError && (
                                                <span
                                                    style={{
                                                        color: "red",
                                                        fontSize: "0.8rem",
                                                        marginTop: "4px",
                                                        display: "block",
                                                    }}
                                                >
                                                    {advPhotoError}
                                                </span>
                                            )}

                                            {/* ✅ Validation error */}
                                            {errors[AF.scorecard] && (
                                                <span className="error-text">{errors[AF.scorecard]}</span>
                                            )}

                                            {/* ✅ Helper text */}
                                            <small
                                                style={{
                                                    color: "#6b7280",
                                                    fontSize: "12px",
                                                    marginTop: "4px",
                                                    display: "block",
                                                }}
                                            >
                                                Max size: 512 KB | Formats: JPG, JPEG, PNG, PDF
                                            </small>
                                        </>

                                        {/* ✅ Preview OR Existing file */}
                                        {advPreview ? (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    marginLeft: 100,
                                                    marginTop: 10,
                                                }}
                                            >
                                                <img src={advPreview} alt="preview" style={{ maxWidth: "40%" }} />
                                            </div>
                                        ) : typeof dataToSave?.jeeadv_scorecard === "string" && dataToSave?.jeeadv_scorecard ? (
                                            <div>
                                                <small
                                                    style={{
                                                        color: "#1d1e1f",
                                                        fontSize: "12px",
                                                        marginTop: "4px",
                                                        display: "block",
                                                    }}
                                                >
                                                    Previous Uploaded File:
                                                </small>

                                                <RenderImage photo={dataToSave?.jeeadv_scorecard} />
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Save Button */}
                    <div className="form-actions gap-2">
                        <button
                            className="save-btn"
                            type="button"
                            onClick={handleCreate}
                            disabled={isSaving}
                            style={{ background: "#28a745" }}
                        >
                            {isSaving ? "Updating..." : "Update"}
                        </button>
                    </div>
                </div>}

            {showConfirmModal && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    backdropFilter: "blur(4px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999,
                    padding: "20px"
                }}>
                    <div style={{
                        backgroundColor: "#fff",
                        padding: "30px",
                        borderRadius: "12px",
                        maxWidth: "450px",
                        width: "100%",
                        boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)",
                        textAlign: "center"
                    }}>
                        <h3 style={{
                            margin: "0 0 15px 0",
                            fontSize: "1.25rem",
                            color: "#1f2937",
                            fontWeight: 600
                        }}>Confirm Update</h3>
                        <p style={{
                            color: "#4b5563",
                            fontSize: "0.95rem",
                            lineHeight: "1.5",
                            marginBottom: "25px"
                        }}>
                            Are you sure you want to update your JEE Main/Advanced details? Please note that you will <strong>NOT</strong> be able to make further edits once submitted.
                        </p>
                        <div style={{   
                            display: "flex",
                            justifyContent: "center",
                            gap: "12px"
                        }}>
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                style={{
                                    padding: "10px 20px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    color: "#374151",
                                    fontSize: "0.95rem",
                                    fontWeight: "500",
                                    cursor: "pointer",
                                    transition: "background-color 0.2s"
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f9fafb"}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}
                            >
                                Close
                            </button>
                            <button
                                onClick={executeSave}
                                disabled={isSaving}
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "8px",
                                    backgroundColor: "#28a745",
                                    color: "#fff",
                                    fontSize: "0.95rem",
                                    fontWeight: "500",
                                    cursor: "pointer",
                                    transition: "background-color 0.2s"
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#218838"}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#28a745"}
                            >
                                {isSaving ? "Submitting..." : "Yes, Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>

    );
}